import React from "react";
import { useTranslation } from "react-i18next";

const AdminModalTailwind = ({ 
  isOpen, 
  onClose, 
  title, 
  subtitle, 
  children, 
  onSave, 
  onCancel,
  saveButtonText,
  cancelButtonText,
  isLoading = false,
  isSaving = false
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSave = () => {
    if (onSave && !isSaving) {
      onSave();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 overflow-y-auto"
      onClick={handleBackdropClick}
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity" />
      
      {/* Modal Container */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-slate-800 shadow-xl transition-all">
          {/* Header */}
          <div className="border-b border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100">
                  {title}
                </h2>
                {subtitle && (
                  <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                    {subtitle}
                  </p>
                )}
              </div>
              <button 
                className="ml-4 p-2 text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-md transition-colors disabled:opacity-50"
                onClick={onClose}
                disabled={isSaving}
                title="Schließen"
              >
                <i className="fas fa-times text-lg"></i>
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="px-6 py-6 bg-white dark:bg-slate-800">
            {children}
          </div>

          {/* Footer */}
          {((saveButtonText != null) || (cancelButtonText != null)) && (
            <div className="border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50 px-6 py-4">
              <div className="flex items-center justify-end gap-3">
                {cancelButtonText != null && (
                  <button 
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 rounded-md transition-colors disabled:opacity-50"
                    onClick={handleCancel}
                    disabled={isSaving}
                  >
                    {cancelButtonText}
                  </button>
                )}
                {saveButtonText != null && (
                  <button 
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-primary hover:bg-primary-dark dark:bg-primary-light dark:hover:bg-primary rounded-md transition-colors disabled:opacity-50"
                    onClick={handleSave}
                    disabled={isSaving || isLoading}
                  >
                    {isSaving ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-2"></i>
                        {t("admin.saving", "Speichern...")}
                      </>
                    ) : (
                      saveButtonText
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminModalTailwind;